export default __webpack_public_path__ + "static/media/img8.0a1a4361.png";